














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ItemStarActions } from '@/actions/item-star-actions';

import { UserModule, UserStore } from '@/store/modules/user';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { GenericItem } from '../models/items/generic-item-model';

@Component({})
export default class ItemStarWidget extends Vue {
  @Prop(GenericItem) public item!: GenericItem;
  isStarred: boolean = false;
  shouldFlipSaveStateOnMouseLeave = false;

  checkIsStarred() {
    this.isStarred = UserModule.starredItemIds.indexOf(this.item.id) > -1;
  }

  created() {
    this.checkIsStarred();

    this.$store.subscribe((mutation, state: any) => {
      if (mutation.type === UserStore.SET_STARRED_ITEM_IDS_MUTATION && !this.shouldFlipSaveStateOnMouseLeave) {
        this.checkIsStarred();
      }
    });
  }
  
  onMouseLeaveHandler() {
    if (this.shouldFlipSaveStateOnMouseLeave) {
      this.isStarred = !this.isStarred;
      this.shouldFlipSaveStateOnMouseLeave = false;
    }
  }

  toggleStarState() {
    if (this.shouldFlipSaveStateOnMouseLeave) {
      return;
    }

    this.shouldFlipSaveStateOnMouseLeave = true;

    if (this.isStarred) {
      ItemStarActions.unstarItem({
        itemId: this.item.id,
        userId: UserModule.currentUserId
      });
      // this.item.numStars -= 1;
    } else {
      ItemStarActions.starItem({
        itemId: this.item.id,
        userId: UserModule.currentUserId
      });
      // this.list.numSaves += 1;
    }
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }
}
